module.exports = __webpack_public_path__ + "static/rcc-581-study-design-desktop-1c4181cc40f5865e03dbdaf2ffa1ac22.png";